if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
		}

		mount(){

			/* -- > DRAWERS < -- */

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('no-inert') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Sticky header

			if ( this.hasAttribute('data-sticky-header') ) {

				const stickyHeader = document.createElement('div');
				stickyHeader.classList = 'sticky-header site-header'

				if ( this.classList.contains('site-header--style-one-row') ) {

					stickyHeader.innerHTML = `<div class="container--large">
						<div class="${this.querySelector('.header__top').className }" style="height:calc(var(--header-logo) + var(--header-vertical-space))">
							${this.querySelector('.header__top').innerHTML}
						</div>
					</div>`;
					stickyHeader.className = `sticky-header ${this.className}`;
					stickyHeader.classList.remove('site-header--absolute');

				} else {

					stickyHeader.innerHTML = `<div class="header__bottom header-container container--large portable-hide">
						${this.querySelector('.header__bottom').innerHTML}
						<div style="display:flex;gap:15px;">
							${this.querySelector('.area--custom-icon') ? this.querySelector('.area--custom-icon').outerHTML : ''}
							${this.querySelector('.area--search').outerHTML}
							${this.querySelector('.area--account') ? this.querySelector('.area--account').outerHTML : ''}
							${this.querySelector('.area--cart').outerHTML}
						</div>
					</div>
					<div class="site-header element--hide-on-portable-plus">
						${this.querySelector('.header-container--top').innerHTML}
					</div>`;
					
				}
			
				document.body.append(stickyHeader);
				
				stickyHeader.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-sticky`;
				})
				stickyHeader.querySelectorAll('.site-nav [aria-controls]').forEach(elm=>{
					elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
				});

				window.lst = window.scrollY;
				window.lhp = 0;

				const stickyHeaderDeskBound =  this.classList.contains('site-header--style-one-row') ? this.querySelector('.header__top') : this.querySelector('.header__bottom');
				const stickyHeaderMobileBound = this.querySelector('.header__top');

				this.SCROLL_StickyHelper = () => {

					var st = window.scrollY;

					if ( ( st <= 0 || ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top >= 0 : stickyHeaderMobileBound.getBoundingClientRect().top >= 0 ) ) && stickyHeader.classList.contains('show') ) {
						stickyHeader.classList.remove('show');
						return;
					}

					if ( st < 0 || Math.abs(lst - st) <= 5 )
						return;	

					if ( st > window.lhp ) {

						if ( st == 0 && stickyHeader.classList.contains('show') ) {

							stickyHeader.classList.remove('show');

						} else if ( st <= lst && ! stickyHeader.classList.contains('show') ) {

							window.lhp = stickyHeader.offsetTop;
							stickyHeader.classList.add('show');

						} else if ( st > lst && stickyHeader.classList.contains('show') ) {
							stickyHeader.classList.remove('show');
						}

					} 

					window.lst = st;

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});
				
			}

			// drawer connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						if ( elm.hasAttribute('data-js-sidebar-handle-direction') ) {
							elmSidebar.classList.remove('sidebar--left', 'sidebar--right');
							elmSidebar.classList.add(`sidebar--${elm.getAttribute('data-js-sidebar-handle-direction')}`);
						}
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							if ( elm.hasAttribute('data-js-sidebar-handle-direction') ) {
								elmSidebar.classList.remove('sidebar--left', 'sidebar--right');
								elmSidebar.classList.add(`sidebar--${elm.getAttribute('data-js-sidebar-handle-direction')}`);
							}
							elmSidebar.show();
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			});
			if ( this.classList.contains('site-header--alignment-left') || this.classList.contains('site-header--style-one-row') ) {
				document.getElementById('site-search-sidebar').classList.remove('sidebar--left');
				document.getElementById('site-search-sidebar').classList.add('sidebar--right');
			}
			if ( this.classList.contains('site-header--style-one-row') && this.classList.contains('site-header--alignment-center') ) {
				document.getElementById('site-menu-sidebar').classList.remove('sidebar--right');
				document.getElementById('site-menu-sidebar').classList.add('sidebar--left');
			}
			
			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			this.KEYDOWN_EscHelper = e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
				}
			};
			document.addEventListener('keydown', this.KEYDOWN_EscHelper);

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
					--window-width: ${document.body.clientWidth}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
				--window-width: ${document.body.clientWidth}px;
			}`;
			document.body.classList.add('header-loaded');

			// switch menu (on load and on resize)
			this._previousWidth = window.innerWidth;
			this._checkMenuWidth();
			this._checkMenuWidth();

			this.RESIZE_MenuWidthHelper = debounce(()=>{
				const currentWidth = window.innerWidth;
				if ( currentWidth < this._previousWidth ) {
					this._checkMenuWidth();
				}
				this._previousWidth = currentWidth;
			}, 200);
			window.addEventListener('resize', this.RESIZE_MenuWidthHelper);

			// submenu masonry

			document.querySelectorAll('.site-nav.style--classic .submenu-masonry').forEach(elm=>{
				const columns = parseInt(elm.getAttribute('data-columns')) || 1;
				const trigger = elm.closest('.has-submenu');
				if ( ! trigger ) return;
				// Build MiniMasonry on first open (relayout on later opens) inside rAF, once the
				// menu is visible — measuring a hidden menu produced inconsistent column gaps.
				let masonry = null;
				const layoutMasonry = () => requestAnimationFrame(() => {
					if ( typeof MiniMasonry === 'undefined' ) return;
					const width = elm.clientWidth;
					if ( ! width ) return;
					// Read the gutter from the CSS grid-gap so it stays the single source of truth:
					// once items become position:absolute the grid-gap no longer applies, so we feed
					// the same value to MiniMasonry. Measured before masonry-active swaps display to block.
					const styles = getComputedStyle(elm);
					const gutter = parseFloat(styles.columnGap) || 0;
					const gutterY = parseFloat(styles.rowGap) || gutter;
					if ( masonry ) masonry.destroy();
					elm.classList.add('masonry-active');
					masonry = new MiniMasonry({
						container: elm,
						baseWidth: Math.floor((width + gutter) / columns) - gutter,
						gutterX: gutter,
						gutterY: gutterY,
						ultimateGutter: gutterY,
						surroundingGutter: false,
						direction: document.documentElement.getAttribute('dir') === 'rtl' ? 'rtl' : 'ltr'
					});
					elm.querySelectorAll('img').forEach(img => {
						if ( ! img.complete ) {
							img.addEventListener('load', () => { if ( masonry ) masonry.layout(); }, { once: true });
						}
					});
				});
				trigger.addEventListener('mouseenter', layoutMasonry);
				trigger.addEventListener('focusin', layoutMasonry);
			});

			// predictive search

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {

				// predictive search (sidebar)

				document.querySelectorAll('[data-js-open-search-drawer]').forEach(elm=>{
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( ! document.body.classList.contains('predictive-script-loaded') ) {
							document.body.classList.add('predictive-script-loaded')
							const predictiveSearchJS = document.createElement('script');
							predictiveSearchJS.src = KROWN.settings.predictive_search_script;
							document.head.appendChild(predictiveSearchJS); 
						}
						setTimeout(()=>{
							document.querySelector('#search-form-sidebar').focus();
						}, 10)
					});
				});

			} else {

				this.querySelector('search-form').addEventListener('click', e=>{
					e.preventDefault();
					window.location.href = KROWN.settings.routes.search_url;
				});

			}

			// touch menu helpers

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
					}
				})
			}
			let babyMenuTouch = false;
			if ( 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch ) {
				document.querySelectorAll('.style--classic .has-babymenu > a').forEach(elmLink=>{
					const elm = elmLink.parentElement;
					elmLink.addEventListener('click', e=>{
						e.preventDefault();
						e.stopPropagation();
						elm.classList.toggle('focus');
						babyMenuTouch = true;
						closeTouchSubmenus(elm,elm.closest('.has-submenu'));
					})
				})
				document.querySelectorAll('.style--classic .has-submenu > a').forEach(elmLink=>{
					const elm = elmLink.parentElement;
					if ( ! elm.classList.contains('mega-link') ) {
						elmLink.addEventListener('click', e=>{
							e.preventDefault();
							e.stopPropagation();
							if ( ! babyMenuTouch ) {
								elm.classList.toggle('focus');
								closeTouchSubmenus(elm);
							}
							babyMenuTouch = false;
						})
					}
				});
			}

			// tab navigation for the menu

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{

					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'true');
						}
					}
				});	
				
				if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
					elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					});
				}

			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{	

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					}
				});

				if ( elm.querySelector('.babymenu li:last-child a') ) {
					elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
						if ( elm.parentNode.classList.contains('focus') ) {
							elm.parentNode.classList.remove('focus');
							elm.parentNode.setAttribute('aria-expanded', 'false');
						}
					});
				}

			})

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
			window.removeEventListener('scroll', this.SCROLL_StickyHelper);
			if ( this.RESIZE_MenuWidthHelper ) {
				window.removeEventListener('resize', this.RESIZE_MenuWidthHelper);
			}
			if ( this.KEYDOWN_EscHelper ) {
				document.removeEventListener('keydown', this.KEYDOWN_EscHelper);
			}
			document.querySelector('.sticky-header')?.remove();
		}

		disconnectedCallback(){
			this.unmount();
		}

		_checkMenuWidth() {
			
			const header = document.querySelector('.site-header--menu-classic');
			if ( !header ) {
				return;
			}

			const classicMenu = header.querySelector('.area--menu-classic');
			if ( !classicMenu ) {
				return;
			}
			
			const logo = header.querySelector('.area--logo');
			const logoIsCentered = header.classList.contains('header__top--logo-center');
			let availWidthforClassicMenu = 0;

			const headerStyle = window.getComputedStyle(header);
			const headerPaddingRight = parseFloat(headerStyle.getPropertyValue('padding-right'));
		  const headerPaddingLeft = parseFloat(headerStyle.getPropertyValue('padding-left'));
		  const headerRowGap = 10;

			const headerWidth = header.offsetWidth - headerPaddingLeft - headerPaddingRight;
			const logoWidth = logo.offsetWidth;
			const classicMenuWidth = classicMenu.offsetWidth + headerRowGap;
			
			const headerItems = header.children;
		
			// Calculate the total width of the child elements
			let totalWidthOfHeaderItems = 0;
			for (let i = 0; i < headerItems.length; i++) {
				if(headerItems[i].offsetWidth > 0) {
					totalWidthOfHeaderItems += headerItems[i].offsetWidth + headerRowGap;
				}
			}

			totalWidthOfHeaderItems -= headerRowGap; // grid gap for one element (gap is inner space :) )

			if( logoIsCentered ) {
				availWidthforClassicMenu = headerWidth / 2 - logoWidth / 2 - headerRowGap; // consider the gap
			} else {
				let otherElementsWidth = totalWidthOfHeaderItems - logoWidth - classicMenuWidth;
				availWidthforClassicMenu = headerWidth - otherElementsWidth - logoWidth;
			}

			// If no available space for classic menu, convert menu to minimal
			if ( classicMenuWidth > availWidthforClassicMenu ) {
				header.classList.remove('site-header--menu-classic');
				header.classList.add('site-header--menu-minimal');
				classicMenu.remove();
			} 
		}

		_adjustNavLayout() {
			if ( this.querySelector('.site-nav') && this.querySelector('.site-nav').classList.contains('style--classic') ) {

				if ( this.querySelector('nav > ul').scrollWidth > this.querySelector('nav').offsetWidth ) {
					this.classList.add('site-header--swap-menu-style');
					document.body.classList.remove('header--has-two-rows');
					let header = document.getElementById('site-header');
					let twoRowsDetected = header.querySelectorAll('[class*="two-rows"]');
					twoRowsDetected.forEach(el=>{
						el.className = el.className.replace('two-rows', 'one-row');
					});
				}
			}
		}

	}
	
  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/* 
			* generic hide/show functions 
		*/

		show(){

			/*
				FRANTIC 2026-08 (Audit) - Fokus-Verwaltung.

				Bisher wurde der Fokus NUR auf dem Tastaturpfad in den Dialog
				bewegt (siehe der keyup-Handler weiter oben). Wer den Warenkorb
				oder die Suche mit Maus/Touch oeffnete, blieb mit dem Fokus auf
				dem ausloesenden Button - und der landete eine Zeile spaeter im
				inerten Teilbaum. Der Fokus fiel damit auf <body> zurueck, und
				ein Screenreader-Nutzer stand ausserhalb des gerade geoeffneten
				Dialogs.

				Zweitens: window.inertElems wird in diesem Theme EINMAL beim
				Mounten aus `#main > div` plus [data-js-inert] gebaut. Der
				gesamte Footer, die Popups, die Altersabfrage und das
				Exit-Intent-Popup werden in layout/theme.liquid aber NACH
				</main> gerendert - sie waren also nie inert. Mit offenem
				Warenkorb lief die Tabulatortaste aus dem Dialog heraus in
				jeden Footer-Link und das Newsletter-Formular.
			*/
			this._opener = document.activeElement;

			this._opened = true;
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			if ( this.id == 'site-cart-sidebar' ) {
				const cartViewEvent = this.querySelector('[data-js-cart-view-event]');
				if ( cartViewEvent && typeof cartViewEvent.dispatchViewEvent === 'function' ) {
					cartViewEvent.dispatchViewEvent();
				}
			}
			if ( this.id == 'site-cart-sidebar' && document.getElementById('cart-recommendations-sidebar') ) {
				setTimeout(()=>{
					document.querySelector('#cart-recommendations-sidebar css-slider')?.resetSlider();
				}, 10);
			}
			this.style.display = 'grid';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');

				/*
					================================================================
					FRANTIC 2026-08-11 (Bugfix): DAS MOBIL-MENUE WAR TOT.

					FEHLERBILD: Das Menue fuhr auf, aber nichts darin reagierte -
					weder die Links noch das X noch die Chevrons. Warenkorb und
					Suche waren unauffaellig.

					HIER STAND:
					  this._inerted = Array.prototype.filter.call(
					    document.body.children,
					    elm => elm !== this && ...
					  );

					Also: jedes direkte Kind von <body> inert setzen, ausser dem
					Dialog selbst. `inert` macht einen Teilbaum laut Spezifikation
					nicht nur unfokussierbar, sondern verwirft auch Pointer-Events.

					Die Pruefung `elm !== this` traegt aber nur, wenn der Drawer
					SELBST ein direktes Kind von <body> ist. Das gilt fuer zwei
					von drei Drawern:

					  layout/theme.liquid    site-cart-sidebar     <- Body-Kind
					  layout/theme.liquid    site-search-sidebar   <- Body-Kind
					  sections/header.liquid site-menu-sidebar     <- NICHT

					Das Menue-Drawer steht in der Header-Section. Shopify rendert
					jede Section in einen eigenen <div class="shopify-section">,
					und DIESER Wrapper ist das Body-Kind. Er ist ungleich `this`,
					wurde also inert - und nahm das Menue in seinem Inneren mit.
					Dass das Panel trotzdem auffuhr, lag daran, dass die Animation
					nur an CSS-Klassen auf <body> und dem Drawer haengt.

					JETZT: statt "alle Body-Kinder ausser dem Dialog" wird der Pfad
					vom Dialog bis <body> hochgelaufen und auf jeder Ebene werden
					die GESCHWISTER inert gesetzt. Bedienbar bleibt genau die Kette
					vom Dialog nach oben, alles daneben nicht. Die Fokusfalle wird
					dadurch nicht schwaecher, sondern praeziser - und sie ist
					unabhaengig davon, wie tief ein Drawer im Dokument haengt.

					Fuer Warenkorb und Suche ist das Ergebnis identisch zu vorher:
					eine Ebene, Geschwister = alle anderen Body-Kinder.

					.site-overlay MUSS ausgenommen bleiben: es ist ein direktes
					Kind von <body> und traegt den Klick-Handler, der den Drawer
					schliesst, wenn man daneben tippt. Inert wuerde dieses
					Schliessen abschalten. Die Ausnahme schwaecht die Fokusfalle
					nicht: das Overlay ist ein leeres <div> ohne fokussierbaren
					Inhalt.
					================================================================
				*/
				const skipTags = { SCRIPT: 1, LINK: 1, STYLE: 1, TEMPLATE: 1, NOSCRIPT: 1 };
				const inerted = [];
				let node = this;

				while ( node && node !== document.body && node.parentElement ) {
					const parent = node.parentElement;
					Array.prototype.forEach.call(parent.children, sib => {
						if ( sib === node ) return;
						if ( skipTags[sib.tagName] ) return;
						if ( sib.classList.contains('site-overlay') ) return;
						if ( sib.hasAttribute('inert') ) return;
						sib.setAttribute('inert', '');
						inerted.push(sib);
					});
					node = parent;
				}

				this._inerted = inerted;

				/* immer in den Dialog fokussieren, nicht nur per Tastatur */
				const firstFocus = this.querySelector('[data-js-close]')
					|| this.querySelector('input, button, a[href], [tabindex]:not([tabindex="-1"])')
					|| this;
				try { firstFocus.focus({ preventScroll: true }); } catch (e) { firstFocus.focus(); }
			}, 15);

		}

		hide(){

			this._opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			if ( this._inerted ) {
				this._inerted.forEach(elm=>{
					elm.removeAttribute('inert');
				})
				this._inerted = null;
			}
			if ( window.inertElems ) {
				window.inertElems.forEach(elm=>{
					elm.removeAttribute('inert');
				})
			}

			document.querySelector(`[aria-controls="${this.id}"]`)?.setAttribute('aria-expanded', 'false');

			/*
				FRANTIC 2026-08 (Audit): Fokus zurueck zum Ausloeser.
				hide() enthielt bisher keinerlei .focus() - wer das Menue
				schloss, landete wieder ganz oben im Dokument und musste sich
				erneut durch die gesamte Navigation tabben.
			*/
			const opener = this._opener || document.querySelector(`[aria-controls="${this.id}"]`);
			if ( opener && typeof opener.focus === 'function' && document.body.contains(opener) ) {
				try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); }
			}
			this._opener = null;

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			this.querySelectorAll('.has-submenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu')
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this.#resizeContainer();
				})
			});

			this.querySelectorAll('.has-babymenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						this.classList.add('opened-second-submenu')
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this.#resizeContainer();
				})
			});

			/* FRANTIC 2026-08: Das Zurueck-Element war ein <a> ohne href und damit
			   nicht fokussierbar - im mobilen Menue kam man per Tastatur in eine
			   Unterebene hinein, aber nicht wieder heraus. Es ist jetzt ein
			   <button>. Der alte Selektor bleibt fuer den Fall stehen, dass
			   irgendwo noch ein <a> gerendert wird. */
			this.querySelectorAll('.submenu-back a, .submenu-back button').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						this.#resizeContainer();
					} else if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						this.#resizeContainer(true);
					}
					this.closest('sidebar-drawer').scrollTo({top: 0});
					setTimeout(()=>{
						e.target.closest('li.opened').classList.remove('opened');
					}, 301);
					e.preventDefault();
				})
			});

		}

		#resizeContainer(main=false){
			if ( main ) {
				this.style.height = `auto`;
			} else {
				if ( this._openedSecondSubmenu ) {
					this.style.height = `${this.querySelector('.has-babymenu.opened .babymenu').scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.has-submenu.opened .submenu').scrollHeight}px`;
				}  
			}
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}